











import globals from "@/general/store/modules/globals";
import { Prop, Vue, Component } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";

@Component
export default class IconUserRank extends Vue {
  @Prop({ type: Number, default: 48 }) size!: number;
  @Prop({ type: [Number, Boolean], default: false }) spSize!: number;

  isSp = globals.isSpScreenWidth;

  get setStyleObj() {
    const size = this.size;
    const spSize = this.spSize;
    const isSp = this.isSp;
    const spImageSize = spSize || size;
    const resultImageSize = isSp ? spImageSize : size;
    const calcRem = (value: any) => `${value / 16}rem`;

    return {
      width: calcRem(resultImageSize),
      minWidth: calcRem(resultImageSize),
      maxHeight: "30px",
    };
  }

  get commonUserInfo(){
    return commons?.userInfo
  }
}
